import { isThemePreset } from '~/stores/theme'

export default defineNuxtPlugin((nuxtApp) => {
  const theme = useThemeStore()
  const route = useRoute()

  // 等 hydration 完成后再读 localStorage / URL，避免与 SSR 默认值不一致导致 class mismatch
  // html 主题 class 仍由 nuxt.config 的 theme-boot 脚本在首屏前应用，不会闪烁
  nuxtApp.hook('app:mounted', () => {
    theme.init()
  })

  watch(
    () => route.query.theme,
    (q) => {
      if (typeof q === 'string' && isThemePreset(q)) {
        theme.setTheme(q)
      }
    },
  )
})
